/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { Txn } from '@src/app/model/txn';
import { catchError, map } from 'rxjs/operators';
import { MailItem } from '@src/app/model/mailMerge';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl(): string {
        return this.getAjaxPath(Txn.TYPE.INVOICE.code);
    }
    protected cache: Txn[];
    protected typeString = Txn.TYPE.INVOICE.name;

    regeneratePDF(txn: Txn) : Observable<Txn> {
        const url = `${this.baseUrl}/${txn.id}/regeneratePDF`;
        return this.http.post<Txn>(url, {}, this.getSimpleOptions(txn.teamId)).pipe( map(response => {
            if (response) {
                this.messageService.show($localize `The PDF for this invoice was successfully regenerated`);
            }
            return response;
        }), catchError(this.handleOneError<Txn>('getAudit' + this.typeString, null)));
    }

    getPDF(txn: Txn, mailIt = false, personId = null) {
        const url = `${this.baseUrl}/${txn.id}/pdf`;
        if (!mailIt) {
            this.downloadFile(url, txn.teamId, 'application/pdf');
        } else {
            return this.http.post(url, {personId}, this.getSimpleOptions(txn.teamId)).pipe( map(response => {
                this.messageService.show('PDF Sent');
                return response;
            }), catchError(this.handleOneError<MailItem>('getAudit' + this.typeString, null)));
        }
    }

}
